//React
import React from 'react';
import {
  withRouter,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as memoAction from '../action/memoAction';
import * as nondisplayAction from '../action/nondisplayAction';
import * as refusalAction from '../action/refusalAction';
import * as breachAction from '../action/breachAction';
import * as mailGroupAction from '../action/mailGroupAction';
import * as footprintAction from '../action/footprintAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';

//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

//Add
import TextareaAutosize from 'react-textarea-autosize';
//Icon
import PersonIcon from '@material-ui/icons/Person';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import CloseIcon from '@material-ui/icons/Close';
import LocalOfferRoundedIcon from '@material-ui/icons/LocalOfferRounded';
import PetsIcon from '@material-ui/icons/Pets';
import BlockIcon from '@material-ui/icons/Block';
import WarningIcon from '@material-ui/icons/Warning';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      pic: props.pic,
      select: null,
      memoTextarea: '',
      breachTextarea: '',
      defaultColor:'#666',
      refusalButtonOpen: false,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.partnerOperation.pic !== prevProps.partnerOperation.pic) {
      if (this.props.partnerOperation.pic) {
        let select;
        if (this.props.partnerOperation.menu.length === 1) {
          select = this.props.partnerOperation.menu[0];
        }
        else {
          select = null;
        }

        this.setState({
          select:　select,
          memoTextarea: this.props.partnerOperation.memo,
          refusalButtonOpen: false,
        });
      }
    }
  }

  _memoEditSubmit() {
    this.props.memoListEdit(this.props.partnerOperation.pic, this.state.memoTextarea);
    this.props.partnerOperationClose()
  }

  _nondisplayEditSubmit() {
    this.props.nondisplayEdit(this.props.partnerOperation.pic);
    this.props.partnerOperationClose()
  }

  _refusalEditSubmit() {
    this.props.refusalEdit(this.props.partnerOperation.pic);
    this.props.partnerOperationClose()
  }

  _breachAddSubmit() {
    this.props.breachAdd(this.props.partnerOperation.pic, this.state.breachTextarea, () => {
      this.setState({ breachTextarea: '' })
    });
    this.props.partnerOperationClose()
  }

  _footprintMyDelSubmit() {
    this.props.footprintMyItemDel(this.props.partnerOperation.pic);
    this.props.partnerOperationClose()
  }

  _footprintPartnerDelSubmit() {
    this.props.footprintPartnerItemDel(this.props.partnerOperation.pic);
    this.props.partnerOperationClose()
  }

  _renderMenu(item, index) {
    if (item === "linkProfile" && this.props.my.profile.userdata_opposite_sex === this.props.partnerOperation.partnerSex) {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => {
            this.props.history.push('/partner/' + this.props.partnerOperation.pic);
            this.props.partnerOperationClose();
          }}
        >
          <div
            className='inner'
          >
            <div className='icon'><PersonIcon /></div>
            <div className='text'>プロフィール</div>
          </div>
        </div>
      )
    }
    else if (item === "memo" && this.props.my.profile.userdata_opposite_sex === this.props.partnerOperation.partnerSex) {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'memo' }) }
        >
          <div
            className='inner'
            style={{ color: (this.props.partnerOperation.memo.length > 0) ? '#CB0077' : this.state.defaultColor}}
          >
            <div className='icon'><LocalOfferRoundedIcon /></div>
            <div className='text'>メモ帳</div>
          </div>
        </div>
      )
    }
    else if (item === "nondisplay") {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'nondisplay' }) }
        >
          <div
            className='inner'
            style={{ color: (this.props.partnerOperation.isNondisplay) ? '#CB0077' : this.state.defaultColor}}
          >
            <div className='icon'><VisibilityOffIcon /></div>
            <div className='text'>表示しない</div>
          </div>
        </div>
      )
    }
    else if (item === "footprintMyDel" && (this.props.partnerOperation.isFootprint) && this.props.my.profile.userdata_opposite_sex === this.props.partnerOperation.partnerSex) {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'footprintMyDel' }) }
        >
          <div className='inner'>
            <div className='icon'><PetsIcon/></div>
            <div className='text'>足あと削除</div>
          </div>
        </div>
      )
    }
    else if (item === "footprintPartnerDel" && this.props.my.profile.userdata_opposite_sex === this.props.partnerOperation.partnerSex) {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'footprintPartnerDel' }) }
        >
          <div className='inner'>
            <div className='icon'><PetsIcon/></div>
            <div className='text'>足あと削除</div>
          </div>
        </div>
      )
    }
    else if (item === "refusal") {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'refusal' }) }
        >
          <div
            className='inner'
            style={{ color: (this.props.partnerOperation.isRefusal) ? '#CB0077' : this.state.defaultColor}}
          >
            <div className='icon'><BlockIcon/></div>
            <div className='text'>ブロック</div>
          </div>
        </div>
      )
    }
    else if (item === "breach") {
      return (
        <div
          key={index}
          className='item'
          onClick={ () => this.setState({ select:'breach' }) }
        >
          <div className='inner'>
            <div className='icon'><WarningIcon /></div>
            <div className='text'>違反通報</div>
          </div>
        </div>
      )
    }
  }



	render() {
    let title;

    if (this.state.select === 'memo') {
      title = 'メモ';
    }
    else if (this.state.select === 'nondisplay') {
      title = '表示しない';
    }
    else if (this.state.select === 'footprintMyDel') {
      title = '足あと削除';
    }
    else if (this.state.select === 'footprintPartnerDel') {
      title = '足あと削除';
    }
    else if (this.state.select === 'refusal') {
      title = 'ブロック';
    }
    else if (this.state.select === 'breach') {
      title = '違反通報';
    }
    else {
      title = this.props.partnerOperation.partnerName + 'さん';
    }


  		return (
        <Dialog
          open={ (this.props.partnerOperation.pic ? true : false )}
          onClose={ () => this.props.partnerOperationClose() }
        >
          <div
            style={{
              maxWidth:'420px',
              minWidth:'260px',
            }}
          >
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >
              <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                { title }
              </div>
              {
                (this.props.partnerOperation.menu.length === 1) ? (
                  <IconButton
                    onClick={ () => this.props.partnerOperationClose() }
                  >
                    <CloseIcon/>
                  </IconButton>
                ): (
                  <div>
                    {
                      (this.state.select === null) ? (
                        <IconButton
                          onClick={ () => this.props.partnerOperationClose() }
                        >
                          <CloseIcon/>
                        </IconButton>
                      ): (
                        <IconButton
                          onClick={ () => this.setState({select: null})}
                        >
                          <ExpandLessIcon />
                        </IconButton>
                      )
                    }
                  </div>
                )

              }
            </div>

      			<DialogContent style={{padding:'10px'}}>
              {
                (this.state.select === null) && (
                <div className='partner_operation_menu'>
                  {
                    this.props.partnerOperation.menu.map(
                      (value, index) => this._renderMenu(value, index)
                    )
                  }
                </div>
                )
              }
              {
                (this.state.select === 'memo') &&
                <div>
                  <div>「{ this.props.partnerOperation.partnerName }」さんのメモ</div>
                  <div style={{color:'#666'}}>100文字以内</div>
                  <TextareaAutosize
                    value={this.state.memoTextarea}
                    className= {(this.state.memoTextarea.length > 100) ? "input_red round6" : "input_blue round6"}
                    onChange={(e) => this.setState({ memoTextarea: e.target.value})}
                    style={{fontSize:'1.2em',minWidth:'240px'}}
                  />
                  {
                    (this.state.memoTextarea.length > 100) && (
                      <div align='right' style={{color:'red'}}>100文字以内で記入してください</div>
                    )
                  }
                  <div align='right'>
                    <span>{this.state.memoTextarea.length}/100文字</span>
                  </div>
                  <div align='right'>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize:'1.1em'}}
                      onClick={ () => this._memoEditSubmit() }
                      disabled={ this.state.memoTextarea.length > 100 }
                    >
                      保存する
                    </Button>
                  </div>
                </div>
              }
              {
                (this.state.select === 'nondisplay') &&
                <div>
                  {
                    (　this.props.partnerOperation.isNondisplay ) ? (
                      <div>
                        「{ this.props.partnerOperation.partnerName }」さんを表示しない設定から解除しますか？
                      </div>
                    ) : (
                      <div>
                        <div>
                          「{ this.props.partnerOperation.partnerName }」さんを表示しない設定にしますか？
                        </div>
                        <div style={{color:'#666',fontSize:'0.9em'}}>
                          設定するとあなたの会員検索、みんなの投稿、みんなのQ&Aに「{this.props.partnerOperation.partnerName }」さんは表示されなくなります。<br/>
                          ※「{this.props.partnerOperation.partnerName }」さんから見られなくなる機能ではありません
                        </div>
                      </div>
                    )
                  }
                  <div style={{margin:'5px'}}>
                    <Button
                      color="primary"
                      variant={ "outlined" }
                      onClick={ () => this.props.helpOpen('category','hide') }
                    >
                      「表示しない」を詳しく
                    </Button>
                  </div>
                  <div align='right'>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize:'1.1em'}}
                      onClick={ () => this._nondisplayEditSubmit() }
                    >
                      はい
                    </Button>
                  </div>
                </div>
              }
              {
                (this.state.select === 'refusal') &&
                <div>
                  {
                    (this.props.partnerOperation.isRefusal) ? (
                      <div>
                        <div>
                          ブロックを解除しますか？
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          「{this.props.partnerOperation.partnerName }」さんをブロックに設定しますか？
                        </div>
                        <div style={{color:'#666',fontSize:'0.9em',margin:'5px'}}>
                          設定すると「{this.props.partnerOperation.partnerName }」さんの「さがす」や「足あと」、「みんなの･･･」などであなたは表示されなくなります。<br/>
                          あなたのプロフィールも停止中となり表示されません。<br/>
                          (停止中と表示されるためブロックされたのかの判別はできません)
                        </div>
                        <div style={{color:'#666',fontSize:'0.9em',margin:'5px'}}>
                          また同様にあなた側も「{this.props.partnerOperation.partnerName }」さんが表示されなくなります。
                        </div>
                        <div style={{color:'#666',fontSize:'0.9em',margin:'5px'}}>
                          メールも送受信できなくなります。<br/>
                          双方ですべて機能で完全に遮断されます。
                        </div>
                        <div style={{margin:'5px'}}>
                          <Button
                            color="primary"
                            variant={ "outlined" }
                            onClick={ () => this.props.helpOpen('category','block') }
                          >
                            「ブロック」を詳しく
                          </Button>
                        </div>
                      </div>
                    )
                  }
                  <div align='right'>
                    {
                      (this.state.refusalButtonOpen) ? (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{fontSize:'1.1em'}}
                          onClick={ () => this._refusalEditSubmit() }
                        >
                          設定する
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{fontSize:'1.1em'}}
                          onClick={ () => this.setState({refusalButtonOpen: true}) }

                        >
                          確認
                        </Button>

                      )
                    }
                  </div>
                </div>
              }
              {
                (this.state.select === 'breach') &&
                <div>
                  利用規約違反やマナー違反と思われる方を<br/>カスタマーサポートに報告していただくフォームです。
                  <div style={{margin:'5px'}}>
                    <Button
                      color="primary"
                      variant={ "outlined" }
                      onClick={ () => this.props.helpOpen('category','violation') }
                    >
                      「違反通報」を詳しく
                    </Button>
                  </div>
                  <div>違反内容をなるべく詳しく記入してください</div>
                  <TextareaAutosize
                    value={this.state.breachTextarea}
                    className="input_blue round6"
                    onChange={(e) => this.setState({ breachTextarea: e.target.value})}
                    style={{fontSize:'1.2em'}}
                  />
                  <div style={{fontSize:'0.8em',color:'#666'}}>
                    ※通報者の情報を公開することは一切ありません。<br/>
                    また対応には最大限の注意を払いますが、違反内容によっては違反者が推測しやすい場合もございます。<br/>
                    その場合、ブロックなどを行っていただくようお願いする場合がございます。
                  </div>
                  <div align='right'>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize:'1.1em'}}
                      onClick={ () => this._breachAddSubmit() }
                      disabled={ (!this.state.breachTextarea) }
                    >
                      送信する
                    </Button>
                  </div>
                </div>
              }
              {
                (this.state.select === 'footprintMyDel') &&
                <div>
                  {
                    (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) ? (
                      <div>
                        <div>
                          <div>
                            閲覧した足あとを削除するには本人証明が必要です。
                          </div>
                          <Button
                            variant="contained"
                            color="primary"
                            style={{fontSize:'1.1em'}}
                            onClick={ () => {
                              this.props.history.push('/my/proof/');
                              this.props.partnerOperationClose();
                            }}
                          >
                            本人証明を申請する
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div>
                          あなたが「{ this.props.partnerOperation.partnerName }」さんのプロフィールを<br/>閲覧した足あとを削除しますか？
                        </div>
                        <div style={{fontSize:'0.9em',color:'#666'}}>
                          ※足あとは１日に30件まで削除できます。<br/>
                          (残り { this.props.partnerOperation.footprintMyDelRemain }件)
                        </div>
                        {
                          (this.props.partnerOperation.footprintMyDelRemain > 0) ? (
                            <div align='right'>
                              <Button
                                variant="contained"
                                color="primary"
                                style={{fontSize:'1.1em'}}
                                onClick={ () => this._footprintMyDelSubmit() }
                              >
                                はい
                              </Button>
                            </div>
                          ) : (
                            <div align='right'>
                              <div style={{color:'red'}}>本日はこれ以上足あとを削除できません。</div>
                            </div>
                          )
                        }
                      </div>

                    )
                  }

                </div>
              }
              {
                (this.state.select === 'footprintPartnerDel') &&
                <div>
                  <div>
                    「{ this.props.partnerOperation.partnerName }」さんがあなたのプロフィールを閲覧した足あとを削除しますか？
                  </div>
                  <div style={{fontSize:'0.9em',color:'#666'}}>
                    削除したことはお相手からは判りません
                  </div>
                  <div align='right'>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{fontSize:'1.1em'}}
                      onClick={ () => this._footprintPartnerDelSubmit() }
                    >
                      はい
                    </Button>
                  </div>
                </div>
              }

            </DialogContent>
          </div>
        </Dialog>

		  )

	}
}

const mapStateToProps = (state) => {
	return {
    config: state.config,
    my: state.my,
    partner: state.partner,
    partnerOperation: state.partnerOperation,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...memoAction,
    ...nondisplayAction,
    ...refusalAction,
    ...mailGroupAction,
    ...breachAction,
    ...footprintAction,
    ...partnerOperationAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
